/**
 * Normaliza URLs do proxy de logo/avatar (`.../api/logos/proxy/...`) para um caminho
 * RELATIVO (same-origin). O backend persiste a URL com o host de `PRODGY_PUBLIC_URL`
 * embutido no momento do upload; quando esse host diverge da origem da página
 * (ex.: dev gravou `http://localhost:3000`/`:4000` mas a app roda em
 * `https://prodgy-dev...`), dá mixed content + bloqueio de loopback/CORS.
 *
 * Como o `server.js` do web sempre faz proxy de `/api/logos/proxy/*` para o backend
 * na mesma origem, basta descartar o host e manter o caminho a partir do marcador.
 * Imune a drift de env e conserta linhas já gravadas com localhost.
 */
const PROXY_MARKER = '/api/logos/proxy/'

// Tipo de retorno condicional (distribui sobre uniões): preserva exatamente a
// nulabilidade do input (`string` → `string`, `string | undefined` →
// `string | undefined`) sem o cast `as T` inseguro do retorno.
export function sameOriginProxyUrl<T extends string | null | undefined>(
  url: T
): T extends string ? string : T {
  type R = T extends string ? string : T
  if (!url) return url as R
  const idx = url.indexOf(PROXY_MARKER)
  if (idx <= 0) return url as R // já relativo (idx === 0) ou não é URL de proxy
  return url.slice(idx) as R
}
